import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Food Science Lab Safety Toolkit',
  value: '12',
  image: 'https://cdn.magicpatterns.com/uploads/hSuRpCaKkJJfxugCaLHxdP/Diseno_sin_titulo_(45).png',
  desc: 'A complete set of resources for teaching and applying safety standards during every hands-on activity in your Food Science classroom or lab: procedures, personal hygiene, hazard identification, and safety routines.',
  benefit: 'You walk into every lab day with safety fully covered — before the first student touches anything.'
}, {
  id: '02',
  title: '50 Real-World Food Industry Case Studies',
  value: '12',
  image: 'https://cdn.magicpatterns.com/uploads/efCPngBhaZDMwckjdu7982/Diseno_sin_titulo_(44).png',
  desc: '50 cases based on real food industry situations, ready for discussion, analysis, and critical thinking. Covers contamination events, recalls, quality failures, labeling issues, and storage failures.',
  benefit: 'Your students analyze real industry situations — not invented textbook scenarios.'
}, {
  id: '03',
  title: 'Food Science Assessment Bank',
  value: '15',
  image: 'https://cdn.magicpatterns.com/uploads/cbx8JECdJxnEaDZAsUYhdB/Diseno_sin_titulo_(43).png',
  desc: 'A bank of 300 questions with complete answer keys, organized by topic and volume. Includes quizzes, tests, exams, review activities, diagnostic assessments, and formative evaluations.',
  benefit: 'Every assessment you need for an entire year — already written, already answered.'
}, {
  id: '04',
  title: 'Food Science Visual Glossary',
  value: '10',
  image: 'https://cdn.magicpatterns.com/uploads/i1jZs7mvrr1gtBLdxXrXPw/Diseno_sin_titulo_(42).png',
  desc: 'A visual reference glossary with essential Food Science and Food Safety terms, designed to reinforce vocabulary, concepts, processes, equipment, quality control, and production knowledge.',
  benefit: 'The words your students need to know — made visible, clear, and memorable.'
}, {
  id: '05',
  title: 'Food Innovation Project Collection',
  value: '12',
  image: 'https://cdn.magicpatterns.com/uploads/iCD83222d8AAPBjnvH8HNB/Diseno_sin_titulo_(41).png',
  desc: '20 applied projects related to food innovation and product development, fully structured and ready to assign. Includes recipe modification, packaging, labeling, sensory evaluation, sustainability, and market analysis.',
  benefit: '20 ready-to-assign projects that turn your classroom into a real food innovation lab.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-14" data-mp="12dg67s0h27st">
      <div className="max-w-5xl mx-auto" data-id="element-15" data-mp="eoerxo4yk2fm">
        <div className="text-center mb-16" data-id="element-16" data-mp="endhnlvrnjyy">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-17" data-mp="anl40urimnmq">
            Included at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-18" data-mp="id33ki2er6w">
            🎁 The 5 Strategic Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-19" data-mp="5c7nkq5hva71">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative" data-id="element-20" data-mp="3moi71ky1dd8r" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-21" data-mp="9c82sd0f3pf5">
                BONUS {bonus.id}
              </div>
              <div className="grid sm:grid-cols-[7.5rem_1fr] gap-6 items-start" data-id="element-22" data-mp="2u15sny214bqj">
                <img src={bonus.image} alt={`${bonus.title} bonus cover`} className="w-28 sm:w-full h-auto mx-auto drop-shadow-[0_12px_16px_rgba(0,0,0,0.5)]" data-id="element-23" data-mp="2z1aapsil5eiv" />
                <div data-id="element-24" data-mp="3afvho6a949sk">
                  <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-4" data-id="element-25" data-mp="3afde0ol9etam">
                    <Gift size={24} data-id="element-26" data-mp="30ja775fgq6hc" />
                  </div>
                  <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-27" data-mp="30l3iwz4xngw7">{bonus.title}</h3>
                  <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-28" data-mp="214pbrluymnq">
                    <span className="text-gray-400 text-sm" data-id="element-29" data-mp="3t8z9rn7tmel2">
                      Real value: <span className="line-through" data-id="element-30" data-mp="3o8bmncmpqhw4">${bonus.value}</span>
                    </span>
                    <span className="text-gold font-bold ml-2" data-id="element-31" data-mp="3ja9um27b788i">→ FREE</span>
                  </div>
                  <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-32" data-mp="2cu7khj5z1nfz">{bonus.desc}</p>
                  <p className="text-gold-light text-sm italic font-medium" data-id="element-33" data-mp="27uuw2tzgc8ba">{bonus.benefit}</p>
                </div>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-34" data-mp="sbnay1viro82">
          <p className="text-gray-300 mb-2" data-id="element-35" data-mp="1712zdb7kvhkl">Total value of the 5 bonuses</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-36" data-mp="1b24zrvd8dzo5">$61.00</p>
          <p className="text-lg text-white mb-2" data-id="element-37" data-mp="1b0btwiafzjh7">Your price today</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-38" data-mp="1g29epgyhqmc9">🎁 FREE</p>
          <p className="text-sm text-gold-light" data-id="element-39" data-mp="1l0ufbhhnn818">Included only with this offer.</p>
        </motion.div>

        <CountdownTimer data-id="element-40" data-mp="3hte8ojnwbyzr" />
      </div>
    </section>;
}